import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExchangeListComponent } from './exchange-list.component';
import { HeaderModule } from 'src/app/components/header/header.module';
import { MenuModule } from 'src/app/components/menu/menu.module';
import { HeaderInSectionModule } from 'src/app/components/header-in-section/header-in-section.module';
import { BodyExchangeListModule } from './body-exchange-list/body-exchange-list.module';
import { MenuFooterModule } from 'src/app/components/menu-footer/menu-footer.module';
import { ModalModule } from 'src/app/components/dialogs/modal.module';

@NgModule({
  declarations: [
    ExchangeListComponent
  ],
  imports: [
    CommonModule,
    HeaderModule,
    MenuModule,
    HeaderInSectionModule,
    BodyExchangeListModule,
    MenuFooterModule,
    ModalModule
  ], exports: [
    ExchangeListComponent
  ]
})
export class ExchangeListModule { }
